<template>
  <div class="main-wrapper">
    <div class="page-wrapper full-page">
      <div class="page-content d-flex align-items-center justify-content-center">
        <div class="row w-100 mx-0 auth-page">
          <div class="col-md-8 col-xl-6 mx-auto">
            <div class="card">
              <div class="row">
                <div class="col-md-4 pe-md-0">
                  <div class="auth-side-wrapper"></div>
                </div>
                <div class="col-md-8 ps-md-0">
                  <div class="auth-form-wrapper px-4 py-3">
                    <div class="row col-12 d-flex justify-content-center mb-3"><img class="logo" src="/img/logo.png" /></div>
                    <h5 class="text-muted fw-normal mb-4">
                      {{ $t("auth.login.hello") }}
                    </h5>

                    <div class="form-group">
                      <div v-if="message" class="alert alert-danger" role="alert">
                        {{ message }}
                      </div>
                    </div>
                    <form class="forms-sample" id="app" @submit.prevent novalidate>
                      <EmailFiled v-model="user.email" />

                      <PasswordFiled v-model="user.password" />
                      <div>
                        <button class="btn btn-primary btn-block" :disabled="isSignupButtonDisabled || loading"
                          @click="handleLogin">
                          <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                          <span>{{ $t("auth.login.login") }}</span>
                        </button>
                      </div>
                      <a href="recover" class="inline mt-3 tx-13 text-muted">
                        {{ $t("auth.login.reset_password") }}</a>
                      <!-- <a href="signup" class="inline mt-3 tx-13 text-muted">
                        {{ $t("auth.login.notUser") }}</a> -->
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmailFiled from "@/components/forms/EmailField.vue"
import PasswordFiled from "@/components/forms/PassField.vue"
import useSubmitButtonState from "@/modules/UseSubmitButtonState";
import { mapGetters } from 'vuex';
import { reactive } from "@vue/reactivity";
import useFormValidation from "@/modules/useFormValidation";
import store from '@/store';
//import { Field, Form, ErrorMessage } from "vee-validate";
//import * as yup from "yup";

export default {
  name: "auth-page",
  components: {
    EmailFiled,
    PasswordFiled,
  },
  data() {
    return {
      message: "",
      loading: false,
    };
  },
  setup() {
    let user = reactive({
      email: "",
      password: ""
    });
    const { errors } = useFormValidation();
    const { isSignupButtonDisabled } = useSubmitButtonState(user, errors);
    return { user, isSignupButtonDisabled, }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    ...mapGetters(['auth/role', 'auth/getUuid'])
  },

  methods: {
   async handleLogin() {
      this.loading = true; 
     await this.$store.dispatch("auth/login", this.user)
     .then((user) => {
          ////console.log(user)
          // we need to check permission
          if (!store.getters['auth/role']) {
            localStorage.setItem('selectedUser', null);
            this.$router.push({ name: 'orders', params: { UserUUID: store.getters['auth/getUuid'] } });
          } else {
            localStorage.setItem('selectedUser', null);
            this.$router.push({name: 'users', params: { UserUUID: store.getters['auth/getUuid'] }});
          }

        },
        (error) => {
          //console.log("error ==>", error)
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.$swal({
            title: this.message,
            icon: "error",
            position: "top-end",
            timer: "5000",
            allowOutsideClick: false,
            showConfirmButton: false,
            toast: true,
            showDenyButton: false,
            showCancelButton: false,
            showCloseButton: true,
            timerProgressBar: true,
          });
        }
      ); 
    },
  },
};
</script>
<style scoped>
.inline {
  display: inline-block;
}
.logo{
  max-height: 106px;
  max-width: 106px;
}
</style>
